<template>
    <div class="relative">
        <AxiosOverlayer :loading="axiosCall" :position-class="'absolute'"/>
    <div class="md:flex justify-between items-center mb-4">
        <h2 class="flex-grow mb-2 md:mb-0">Meine Projekte</h2>
        <base-button :router-link="true" link="/form" button-class="invert">Neues Projekt</base-button>
    </div>
    <ModalDialog :show="openModal" headline="Speicher-Link">
        <HashCopy :hash-link="hashLink" />
    </ModalDialog>

    <div>
        <ul v-if="projects.length">
            <template v-for="(project, index) in projects">
                <li class="md:flex justify-between py-4" :class="[index != 0 ? 'border-t': '']">
                    <div class="flex-grow whitespace-nowrap mb-3 md:mb-0">
                        <router-link :to="'/form/edit/'+ project.id + '/' + project.version"><span class="font-bold">Objektbezeichnung:</span> {{ project.hash.generalData.name }}{{ project.hash.generalData.projectNumber ? ' - ' + project.hash.generalData.projectNumber : '' }} <span class="text-sm lining-nums tabular-nums" :class="hasCurrentVerion(project.version) ? 'text-gray-300' : 'text-red-700'">(v{{ project.version}}{{ hasCurrentVerion(project.version) ? '' : ' - veraltet'}})</span></router-link>
                    </div>
                    <div class="md:whitespace-nowrap">
                        <router-link class="font-bold border text-xs md:text-base border-primary-default p-2 text-primary-default cursor-pointer hover:text-black mr-2" :to="'/form/edit/' + project.id  + '/' + project.version">bearbeiten</router-link>
                        <router-link class="font-bold border text-xs md:text-base border-primary-default p-2 text-primary-default cursor-pointer hover:text-black mr-2" :to="'/form/result/' + project.id">Ergebnis</router-link>
                        <!--<span class="font-bold text-primary-default mr-2 cursor-pointer hover:text-black" @click="getHashLink(project.id)">link</span>-->
                        <span class="font-bold text-xs md:text-base text-primary-default border border-primary-default p-2 mr-2 cursor-pointer hover:text-black" @click="deleteProject(project.id)">löschen</span>
                        <span class="font-bold text-xs md:text-base text-primary-default border border-primary-default p-2 cursor-pointer hover:text-black" @click="getPdf(project.id)">PDF</span>

                    </div>
                </li>
            </template>
        </ul>
        <div v-else>
            Keine Projekte angelegt
        </div>
    </div>
    </div>
</template>

<script>
import {useStore} from "vuex";
import {computed, getCurrentInstance, onMounted, ref, reactive} from 'vue';
import {API} from "@/utils/api";
import HashCopy from "../../page/HashCopy";


export default {
    setup() {
        const store = useStore();
        const openModal = ref(false);
        const hashLink = ref('')
        const userData = computed(() => store.getters['Customer/userData']);

        const projects = computed(() => store.getters['Project/getProjects'])

        const internalInstance = getCurrentInstance();
        const moment = internalInstance.appContext.config.globalProperties.$moment;
        const emitter = internalInstance.appContext.config.globalProperties.$emitter;
        const axiosCall = ref(false);

        onMounted(() => {

            API.get('getProjects').then((resp) => {
                axiosCall.value = false;
                store.dispatch('Project/setProjects', resp.data.projects)

            }).catch(err => {
                axiosCall.value = false
                console.error(err);

                emitter.emit("flash-message", {
                    text: err.response.data.message,
                    type: 'error'
                })
            })
        })

        const getHashLink = (id) => {

            API.post( 'getHashLink',{ id: id}).then((resp) => {
                axiosCall.value = false;
                hashLink.value = resp.data.link + encodeURIComponent(resp.data.hash);
                openModal.value = !openModal.value;
            }).catch(err => {
                axiosCall.value = false
                console.log(err);

                emitter.emit("flash-message", {
                    text: err.response.data.message,
                    type: 'error'
                })
            })
        }

        const deleteProject = (id) => {

            if (!confirm("Are you sure?")) return

            API.delete( 'deleteProject',{ data: {id: id}}).then((resp) => {
                axiosCall.value = false;
                emitter.emit("flash-message", {
                    text: resp.data.message,
                    type: 'success'
                })

                store.dispatch('Project/setProjects', resp.data.projects)

            }).catch(err => {
                axiosCall.value = false
                console.log(err);

                emitter.emit("flash-message", {
                    text: err.response.data.message,
                    type: 'error'
                })

            })

        }

        const getPdf = (projectId) => {

            axiosCall.value = true;

            const pdfData = {id: projectId}

            API.post('getPdf',
                pdfData,
                {
                    'responseType': 'blob',
                    'Accept': 'application/pdf'
                }
            ).then((response) => {
                axiosCall.value = false;
                console.log(response.data);

                const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}));
                const link = document.createElement('a');
                console.log(link);
                link.href = url;
                let now = new Date();


                link.setAttribute('download', 'bdew_'+moment(now).format('YYYY-MM-DD')+'_projekt_'+pdfData.id+'.pdf'); //or any other extension
                document.body.appendChild(link);
                link.click();

            }).catch(err => {
                axiosCall.value = false
                console.error(err);

                emitter.emit("flash-message", {
                    text: err.response.data.message,
                    type: 'error'
                })

            })
        }

        const hasCurrentVerion = (version) => version.localeCompare(window.APP_VERSION, undefined, { numeric: true, sensitivity: 'base' }) === 0

        return {
            userData,
            axiosCall,
            projects,
            deleteProject,
            getHashLink,
            openModal,
            hashLink,
            getPdf,
            hasCurrentVerion
        }
    }
}
</script>
